// test1242
(1242 && 0);
